import React from 'react';
import { SelectBaseProps } from './types';
import MobileSelect from './MobileSelect';
import WebSelect from './WebSelect';
import { useIsMobileLayout } from '../../../../hooks/useIsMobileLayout';

export type { SelectBaseProps };

const SelectBase: React.FC<SelectBaseProps> = (props) => {
    const isMobileLayout = useIsMobileLayout();
    return isMobileLayout ? <MobileSelect {...props} /> : <WebSelect {...props} />;
};

export default React.memo(SelectBase);
